/**
 * Extract email_verified from JWT access token
 */
export function extractEmailVerifiedFromAccessToken(accessToken: string): boolean {
  try {
    const parts = accessToken.split('.')
    if (parts.length !== 3) {
      return false
    }

    const payload = JSON.parse(atob(parts[1]))
    return payload.email_verified === true
  } catch {
    return false
  }
}
